import {FETCH_BASE_TOKEN, FETCH_LOGIN_TOKEN, REFRESH_LOGIN_TOKEN, LOGOUT} from '../actions/types';

export const authReducer = (state = {} , action) => {
    switch(action.type) {
        case FETCH_BASE_TOKEN:
            return {...state, baseToken: action.payload} || false;
        case FETCH_LOGIN_TOKEN:
            return {...state, loginToken: action.payload} || false;
        case REFRESH_LOGIN_TOKEN:
            if(action.payload){
                return {...state, loginToken: action.payload} || false;
            } else {
                return state;
            }
        case LOGOUT:
            return  Object.keys(state).reduce((acc, key) => {
                return key === 'loginToken' ? acc : {...acc, [key]:state[key]}
            }, {}) || false;
        default:
            return state;
    }
}